var map = {
	"./《微电网建设应用探索实践》1125-对外终版_12.png": 95620,
	"./《微电网建设应用探索实践》1125-对外终版_13.png": 58861,
	"./《微电网建设应用探索实践》1125-对外终版_14.png": 28882,
	"./《微电网建设应用探索实践》1125-对外终版_15.png": 50427,
	"./《微电网建设应用探索实践》1125-对外终版_16.png": 69216,
	"./《微电网建设应用探索实践》1125-对外终版_17.png": 93417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71075;